<template>
  <div> 
    <CustomDialog ref='pdnProfile' :element='dialog.element.elePdnProfile' :styles='dialog.styles' :messages='dialog.messages.pdnProfile'>
      <template v-slot:dialog-content>
        <div>
          <ejs-grid ref='grid' :dataSource="data" height='100%' :rowDeselected='getCheckedCount' :rowSelected='getCheckedCount' :allowReordering='true' :allowResizing='true'>
            <e-columns>
              <e-column field='dnnProfileId' :headerText='$t("Snssai.dnnProfile")' width='20%' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
              <e-column field='dnnProfileName' :headerText='$t("Snssai.dnnProfileName")' width='30%' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
             <e-column field='pduSessionTypes' :headerText='$t("DNN.pduSessionType")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>

            </e-columns>
          </ejs-grid>
          <!-- <ejs-pager ref='pager' @click='qryList()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager> -->
        </div>
      </template>
    </CustomDialog>
  </div>
</template>
<script>

import CustomDialog from '../../../../common/CustomDialog';
import ajaxUrl from "../../../data/ajaxUrl";

export default {
  name: "DnnProfileList",
  components: {
    CustomDialog,
  }, 
  props: [
    'getCheckedDatas',
  ],
  methods: {
    qryList(ne,profileId) {
      // this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = {
        vo: {
          userProfileId:parseInt(profileId)
        }, 
        info: {
          msgid: "28697",
          neid: ne.neid,
        },
        // page: {
        //   pageNo: this.page.pageNo,
        //   pageSize: this.page.pageSize,
        // },
      };
      console.log('params=', params);
      this.$axios.post(ajaxUrl.requestCommonD, params).then((response) => {
        if (!response) {
          console.log("qryPdnProfile response error");
          return;
        }
        if (!response.data) {
          console.log("qryPdnProfile response.data error");
          return;
        }        
        if (!response.data.resultVal) {
          console.log("qryPdnProfile response.data.resultVal error");
          return;
        }    
                  console.log("response",response);

        const res = response.data.resultVal;
                          console.log("res",res);

        if (res) {
                  if (res.pduSessTypes) {
          this.data = res.pduSessTypes.map(item => {

          var type="";
            if(item.pduSessionTypes[0]==1){
              type=this.$t("DNN.pduType0")+';'
              }
            if(item.pduSessionTypes[1]==1){
              type=type+this.$t("DNN.pduType1")+';'
              }
            if(item.pduSessionTypes[2]==1){
              type=type+this.$t("DNN.pduType2")+';'
              }
            if(item.pduSessionTypes[3]==1){
              type=type+this.$t("DNN.pduType3")+';'
              }
            if(item.pduSessionTypes[4]==1){
              type=type+this.$t("DNN.pduType4")
              }

            return {
              ...item,
              "pduSessionTypes": type,
            }
          });
        }
          this.data = res.pduSessTypes;        
          // this.page.pageCount = res.page;
          // this.page.totalCount = res.countRsp;
          // this.page.pageCount = Math.ceil(res.countRsp / this.page.pageSize);
        }   
      });
    },
    show() {
      this.$refs.pdnProfile.show();
    },
    save() {
      const checkedKeys = this.getCheckedKeys();
      if(checkedKeys) {
        if(this.getCheckedDatas) {
          this.getCheckedDatas(checkedKeys);
        }
        this.close();
        return;
      }
    },
    close() {
      this.$refs.pdnProfile.clear();
      this.$refs.pdnProfile.close();
    },
    getCheckedRecords() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      return selectedRecords;
    },
    getCheckedKeys() {
      // x-> false: 不支持多选   true: 支持多选
      const dnnProfileId = [];
      const checkedData = this.getCheckedRecords();
      for (let i = 0; i < checkedData.length; i++) {
        dnnProfileId.push({
          dnnProfileId:checkedData[i].dnnProfileId,
          pdnType: this.getKey(this.descPDU, checkedData[i].pduSessionTypes),
        }
          );
      }
      return dnnProfileId.length === 0 ? null : dnnProfileId;
    },
    getCheckedCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.checkedCount = selectedRecords.length;
    },
        getKey(obj, value) {
      for(let key in obj){
        if (value === obj[key]) {
          return Number(key);
        }
      }
    },
  },
  data() {
    return {
      data: {},
      checkedCount: 0,
      page: {
        pageNo: '1',
        pageSize: '15',
        totalCount: '0',
        pageCount: '0',
      },
      dialog: {
        styles: {
          width: '50%',
          height: '60%',
          visible: false,
          model: true,
          zIndex: 1001
        },
        element: {
          elePdnProfile: {
            target: this.$refs.pdnProfile,
            refName: 'elePdnProfile',
            buttonGroup: [
              { click: this.save, buttonModel: { content: this.$t("Profile.confirm"), isPrimary: true } },
              { click: this.close, buttonModel: { content: this.$t("Profile.cancel") } }
            ],
            title: this.$t("Snssai.dnnProfileList"),
            isClose: true,
          },     
        },
        messages: {
          pdnProfile: {
            title: this.$t("Snssai.dnnProfileList"),
          },          
        },
      }, 
        descPDU: {
        0: this.$t("DNN.pduType0"),
        1: this.$t("DNN.pduType1"),
        2: this.$t("DNN.pduType2"),
        3: this.$t("DNN.pduType3"),
        4: this.$t("DNN.pduType4"),
      },     
    };
  },
};
</script>
